"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gordona": {
    "bdb57a77": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "skipSearch": false
    }],
    "bortolotto": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gordona"
    }],
    "b3dbb7cd": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "skipSearch": false
    }],
    "castanedi": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gordona"
    }],
    "a78bfb2c": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "skipSearch": false
    }],
    "foppo": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "39770df1": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "skipSearch": false
    }],
    "gradesella": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gordona"
    }],
    "7a15647a": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "skipSearch": false
    }],
    "motto": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gordona"
    }],
    "e9a7a4cd": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "skipSearch": false
    }],
    "voga": [{
      "hkey": "8207d702",
      "slug": "menarola",
      "name": "Menarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gordona"
    }]
  }
};
exports["default"] = _default;